const resizeMenu = () => {
    const pageContent = document.getElementById('pageContent');
    const attr = pageContent.firstChild?.getAttribute('view_id');
    $$(attr)?.resize();
};

export default resizeMenu;
